import React from 'react';

import classNames from 'classnames/bind';
import styles from './CloseBtn.scss';
const cx = classNames.bind(styles);

const CloseBtn = React.memo(
  ({ title, className = [], onClick, style = {} }) => {
    return (
      <button
        className={cx('CloseBtn', ...className)}
        onClick={onClick}
        style={style}
      >
        <span className="icon-x">
          <span className="bar" />
          <span className="bar" />
        </span>
      </button>
    );
  },
);

export default CloseBtn;
